import { getStoredUser } from './auth';

/** Права ролей в интерфейсе. Настоящая проверка на сервере, здесь только то, что показывать. */
export const ROLE_LABELS = {
    admin: 'Администратор',
    manager: 'Менеджер',
    receiver: 'Мастер-приёмщик',
    master: 'Мастер',
};

export const normalizeRole = (role) => String(role || '').trim().toLowerCase();

export const getRoleLabel = (role) => ROLE_LABELS[normalizeRole(role)] || '';

export const getCurrentRole = () => normalizeRole(getStoredUser()?.role);

export const isMasterRole = (role) => normalizeRole(role) === 'master';

export const isReceiverRole = (role) => normalizeRole(role) === 'receiver';

/** Суммы заказов, цены услуг и оплата. */
export const canSeePrices = (role) => ['admin', 'manager', 'receiver'].includes(normalizeRole(role));

/** Себестоимость, закупочные цены, финансы, удаление и управление справочниками. */
export const canSeeCosts = (role) => ['admin', 'manager'].includes(normalizeRole(role));

export const canEditOrders = canSeePrices;

/** Цены, услуги, скидку и статус оплаченного или выполненного заказа меняет только руководство. */
export const canChangeOrder = (role, order) => {
    if (canSeeCosts(role)) return true;
    if (!canEditOrders(role)) return false;
    return !(order?.status === 'completed' || Boolean(order?.is_paid));
};

export const isAssignedToOrder = (order, userId) => {
    const id = Number(userId);
    if (!id) return false;
    const ids = [
        order?.master_id,
        ...(Array.isArray(order?.master_ids) ? order.master_ids : []),
        ...(Array.isArray(order?.additional_master_ids) ? order.additional_master_ids : []),
        ...(Array.isArray(order?.masters) ? order.masters.map((master) => master?.id) : []),
    ];
    return ids.some((value) => Number(value) === id);
};

/** Начать и завершить заказ мастер может, только если назначен на него. */
export const canAdvanceOrder = (role, order, userId) => !isMasterRole(role) || isAssignedToOrder(order, userId);

const OFFICE_ONLY_PATHS = [
    '/analytics',
    '/schedule',
    '/accounting',
    '/accounting/expenses',
    '/accounting/legacy',
    '/accounting/template',
    '/settings/currency-rates',
    '/services/new',
    '/services/:id/edit',
];
const MASTER_DENIED_PATHS = ['/orders/new', '/orders/:id/edit'];

export const canAccessPath = (role, path) => {
    const normalized = normalizeRole(role);
    const route = String(path || '');
    if (!normalized) return true;
    if (route.startsWith('/users')) return normalized === 'admin';
    if (canSeeCosts(normalized)) return true;
    if (OFFICE_ONLY_PATHS.includes(route)) return false;
    return !(isMasterRole(normalized) && MASTER_DENIED_PATHS.includes(route));
};

/** Администратор по умолчанию работает в своём отделении, если оно есть в списке. */
export const getDefaultBranchId = (branches, user) => {
    const list = Array.isArray(branches) ? branches : [];
    const own = list.find((branch) => String(branch.id) === String(user?.branch_id));
    const chosen = own || list[0];
    return chosen ? String(chosen.id) : '';
};
